/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Loaderror1Inputs */

const he_items_loaderror1 = /** @type {(inputs: Items_Loaderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שגיאה בטעינת מוצרים`)
};

const en_items_loaderror1 = /** @type {(inputs: Items_Loaderror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading products`)
};

/**
* | output |
* | --- |
* | "Error loading products" |
*
* @param {Items_Loaderror1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const items_loaderror1 = /** @type {((inputs?: Items_Loaderror1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Loaderror1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_items_loaderror1(inputs)
	return en_items_loaderror1(inputs)
});
export { items_loaderror1 as "items_loadError" }